import { jsx as e, jsxs as v, Fragment as z } from "react/jsx-runtime";
import { AlertGroup as $e, Alert as At, AlertVariant as LA, AlertActionCloseButton as et, Page as tt, Modal as ye, ModalVariant as nt, TextContent as rt, Text as jA, Button as X, FormHelperText as FA, HelperText as zA, HelperTextItem as WA, Popover as at, Icon as SA, FormGroup as fe, NumberInput as it, ValidatedOptions as N, InputGroup as DA, InputGroupItem as RA, TextInput as EA, Select as QA, SelectList as MA, SelectOption as KA, MenuToggle as gA, MenuToggleStatus as UA, TextInputGroup as Be, TextInputGroupMain as De, ChipGroup as ZA, Chip as qA, TextInputGroupUtilities as Ee, Switch as st, TextArea as Qe, FileUpload as lt, Title as ot, Card as ct, CardHeader as dt, CardTitle as ut, CardBody as gt, Grid as mt, GridItem as se, PageSection as Ct, JumpLinks as It, JumpLinksItem as ht, ButtonVariant as fA, Checkbox as pt, Radio as vt, MenuFooter as yt, Dropdown as ft, DropdownList as Bt, DropdownItem as le, Masthead as Dt, MastheadBrand as Et, MastheadContent as Qt, Toolbar as yA, ToolbarContent as XA, ToolbarItem as F, Avatar as Mt, Bullseye as wt, Spinner as bt, EmptyState as xt, EmptyStateIcon as oe, EmptyStateHeader as Ot, EmptyStateBody as kt, EmptyStateFooter as Tt, EmptyStateActions as Yt, SearchInput as Jt, Divider as Lt, Pagination as jt, Badge as St } from "@patternfly/react-core";
import { createContext as Me, useContext as we, useRef as U, useEffect as nA, useCallback as uA, useState as w, useMemo as G, forwardRef as Rt, useId as be, Fragment as xe, Children as Oe, Component as Xt, isValidElement as Gt } from "react";
import { useTranslation as S } from "react-i18next";
import { NetworkError as ke } from "@keycloak/keycloak-admin-client";
import Ht from "keycloak-js";
import { ExclamationCircleIcon as Pt, HelpIcon as ce, EyeIcon as Nt, EyeSlashIcon as Vt, TimesIcon as Te, CubeIcon as Ft, PaypalIcon as zt, InstagramIcon as Wt, BitbucketIcon as Kt, MicrosoftIcon as Ut, TwitterIcon as Zt, StackOverflowIcon as qt, OpenshiftIcon as _t, LinkedinIcon as $t, GoogleIcon as An, GitlabIcon as en, FacebookSquareIcon as tn, GithubIcon as nn, MinusCircleIcon as rn, PlusCircleIcon as Ye, EllipsisVIcon as an, SearchIcon as sn, SyncAltIcon as ln } from "@patternfly/react-icons";
import { useFormContext as wA, Controller as iA, useController as bA, FormProvider as on, useWatch as cn } from "react-hook-form";
import { get as R, cloneDeep as dn, intersectionBy as un } from "lodash-es";
import pA from "@patternfly/react-styles/css/components/Avatar/avatar";
import { css as gn } from "@patternfly/react-styles";
import { Table as mn, TableVariant as Cn, Thead as In, Tr as vA, Th as YA, Tbody as de, Td as rA, ExpandableRowContent as hn, ActionsColumn as pn, TableText as vn } from "@patternfly/react-table";
import './main.css';function _A(A, t) {
  const n = Me(t);
  return n.displayName = A, n;
}
const yn = ["error", "errorMessage"], JA = "error_description";
function fn(A) {
  if (typeof A == "string")
    return A;
  if (A instanceof ke)
    return Dn(A.responseData);
  if (A instanceof Error)
    return A.message;
  throw new Error("Unable to determine error message.");
}
function Bn(A) {
  if (!(A instanceof ke))
    return;
  const t = A.responseData;
  return Je(t);
}
function Je(A) {
  if (typeof A == "object" && A !== null && JA in A && typeof A[JA] == "string")
    return A[JA];
}
function Dn(A) {
  if (!(typeof A != "object" || A === null))
    for (const t of yn) {
      const n = A[t];
      if (typeof n == "string")
        return n;
    }
}
const En = () => Math.floor(Math.random() * 1e3);
function Qn(A) {
  return A != null;
}
function $A(A) {
  const t = we(A);
  if (Qn(t))
    return t;
  throw new Error(
    `No provider found for ${A.displayName ? `the '${A.displayName}'` : "an unknown"} context, make sure it is included in your component hierarchy.`
  );
}
function Mn() {
  const A = U(!1), t = U(/* @__PURE__ */ new Set());
  nA(() => (A.current = !1, () => {
    A.current = !0, n();
  }), []);
  function n() {
    t.current.forEach((r) => clearTimeout(r)), t.current.clear();
  }
  return uA((r, a) => {
    if (A.current)
      throw new Error("Can't schedule a timeout on an unmounted component.");
    const i = Number(setTimeout(s, a));
    t.current.add(i);
    function s() {
      t.current.delete(i), r();
    }
    return function() {
      clearTimeout(i), t.current.delete(i);
    };
  }, []);
}
function wn({ alerts: A, onCloseAlert: t }) {
  return /* @__PURE__ */ e(
    $e,
    {
      "data-testid": "global-alerts",
      isToast: !0,
      style: { whiteSpace: "pre-wrap" },
      children: A.map(({ id: n, variant: r, message: a, description: i }, s) => /* @__PURE__ */ e(
        At,
        {
          "data-testid": s === 0 ? "last-alert" : void 0,
          isLiveRegion: !0,
          variant: LA[r],
          component: "p",
          variantLabel: "",
          title: a,
          actionClose: /* @__PURE__ */ e(
            et,
            {
              title: a,
              onClose: () => t(n)
            }
          ),
          children: i && /* @__PURE__ */ e("p", { children: i })
        },
        n
      ))
    }
  );
}
const bn = 8e3, Le = _A(
  "AlertContext",
  void 0
), Xr = () => $A(Le), xn = ({ children: A }) => {
  const { t } = S(), n = Mn(), [r, a] = w([]), i = (c) => a((u) => u.filter((o) => o.id !== c)), s = uA(
    (c, u = LA.success, o) => {
      const h = {
        id: En(),
        message: c,
        variant: u,
        description: o
      };
      a((I) => [h, ...I]), n(() => i(h.id), bn);
    },
    [n]
  ), l = uA(
    (c, u) => {
      const o = t(c, { error: fn(u) }), h = Bn(u);
      s(o, LA.danger, h);
    },
    [s, t]
  ), d = G(() => ({ addAlert: s, addError: l }), [s, l]);
  return /* @__PURE__ */ v(Le.Provider, { value: d, children: [
    /* @__PURE__ */ e(wn, { alerts: r, onCloseAlert: i }),
    A
  ] });
}, On = (A) => {
  const { t } = S(), n = A.error, r = kn(n) || Je(n)?.replace(/\+/g, " ");
  console.error(n);
  function a() {
    location.href = location.origin + location.pathname;
  }
  return /* @__PURE__ */ e(tt, { children: /* @__PURE__ */ e(
    ye,
    {
      variant: nt.small,
      title: r ? "" : t("somethingWentWrong"),
      titleIconVariant: "danger",
      showClose: !1,
      isOpen: !0,
      actions: [
        /* @__PURE__ */ e(X, { variant: "primary", onClick: a, children: t("tryAgain") }, "tryAgain")
      ],
      children: /* @__PURE__ */ e(rt, { children: r ? /* @__PURE__ */ e(jA, { children: t(r) }) : /* @__PURE__ */ e(jA, { children: t("somethingWentWrongDescription") }) })
    }
  ) });
};
function kn(A) {
  return typeof A == "string" ? A : A instanceof Error ? A.message : null;
}
function Tn(A, t, n) {
  const [r, a] = w(
    () => A.getItem(t) ?? n
  ), i = uA((s) => {
    a(s), A.setItem(t, s);
  }, []);
  return nA(() => {
    a(A.getItem(t) ?? n), window.addEventListener("storage", s);
    function s(l) {
      l.storageArea === A && (l.key === null || l.key === t) && a(l.newValue ?? n);
    }
    return () => window.removeEventListener("storage", s);
  }, [A, t]), [r, i];
}
function je(A, t, n) {
  const r = G(
    () => JSON.stringify(n),
    [n]
  ), [a, i] = Tn(
    A,
    t,
    r
  ), s = G(() => JSON.parse(a), [a]), l = uA(
    (d) => i(JSON.stringify(d)),
    []
  );
  return [s, l];
}
const Se = _A(
  "HelpContext",
  void 0
), Yn = () => $A(Se), Jn = ({ children: A }) => {
  const [t, n] = je(localStorage, "helpEnabled", !0);
  function r() {
    n(!t);
  }
  return /* @__PURE__ */ e(Se.Provider, { value: { enabled: t, toggleHelp: r }, children: A });
}, Ln = "data:image/png;base64,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", jn = "data:image/png;base64,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", Sn = () => {
  const { t: A } = S(), [t, n] = w(!1);
  return nA(() => {
    const r = document.documentElement.classList.contains("pf-v5-theme-dark");
    n(r);
  }, []), /* @__PURE__ */ e("div", { id: "spinner_screen", role: "progressbar", style: { display: "block", height: "100%" }, children: /* @__PURE__ */ v("div", { style: { width: 320, height: 328, textAlign: "center", position: "absolute", top: 0, bottom: 0, left: 0, right: 0, margin: "auto" }, children: [
    /* @__PURE__ */ e("img", { src: t ? Ln : jn, alt: "Logo", className: "brand" }),
    /* @__PURE__ */ e("p", { children: A("loadingMessage") }),
    /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", style: { margin: "auto", background: "transparent", display: "block", shapeRendering: "auto" }, width: "200px", height: "200px", viewBox: "0 0 100 100", preserveAspectRatio: "xMidYMid", children: /* @__PURE__ */ e("path", { d: "M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50", fill: "#5DBCD2", stroke: "none", transform: "rotate(16.3145 50 51)", children: /* @__PURE__ */ e("animateTransform", { attributeName: "transform", type: "rotate", dur: "1s", repeatCount: "indefinite", keyTimes: "0;1", values: "0 50 51;360 50 51" }) }) }) })
  ] }) });
}, Rn = () => Me(void 0);
let GA;
const Gr = () => {
  const A = we(GA);
  if (!A)
    throw Error(
      "no environment provider in the hierarchy make sure to add the provider"
    );
  return A;
}, Hr = ({
  environment: A,
  children: t
}) => {
  GA = Rn();
  const n = U(!1), [r, a] = w(!1), [i, s] = w(), l = G(() => {
    const c = new Ht({
      url: A.serverBaseUrl,
      realm: A.realm,
      clientId: A.clientId
    });
    return c.onAuthLogout = () => c.login(), c;
  }, [A]);
  nA(() => {
    if (n.current)
      return;
    l.init({
      onLoad: "check-sso",
      pkceMethod: "S256",
      responseMode: "query",
      scope: A.scope
    }).then(() => a(!0)).catch((u) => s(u)), n.current = !0;
  }, [l]);
  const d = new URLSearchParams(window.location.search);
  return i || d.get("error_description") ? /* @__PURE__ */ e(
    On,
    {
      error: i || d.get("error_description")
    }
  ) : r ? /* @__PURE__ */ e(GA.Provider, { value: { environment: A, keycloak: l }, children: /* @__PURE__ */ e(xn, { children: /* @__PURE__ */ e(Jn, { children: t }) }) }) : /* @__PURE__ */ e(Sn, {});
};
function Pr() {
  const t = document.getElementById("environment")?.textContent;
  if (typeof t != "string")
    throw new Error("Environment variables not found in the document.");
  try {
    return JSON.parse(t);
  } catch {
    throw new Error("Unable to parse environment variables as JSON.");
  }
}
const Nr = ({
  modalTitle: A,
  continueLabel: t,
  cancelLabel: n,
  buttonTitle: r,
  isDisabled: a,
  buttonVariant: i,
  buttonTestRole: s,
  onContinue: l,
  component: d = X,
  children: c,
  ...u
}) => {
  const [o, h] = w(!1);
  return /* @__PURE__ */ v(z, { children: [
    /* @__PURE__ */ e(
      d,
      {
        variant: i,
        onClick: () => h(!0),
        isDisabled: a,
        "data-testrole": s,
        children: r
      }
    ),
    /* @__PURE__ */ e(
      ye,
      {
        variant: "small",
        ...u,
        title: A,
        isOpen: o,
        onClose: () => h(!1),
        actions: [
          /* @__PURE__ */ e(
            X,
            {
              id: "modal-confirm",
              variant: "primary",
              onClick: () => {
                h(!1), l();
              },
              children: t
            },
            "confirm"
          ),
          /* @__PURE__ */ e(
            X,
            {
              id: "modal-cancel",
              variant: "secondary",
              onClick: () => h(!1),
              children: n
            },
            "cancel"
          )
        ],
        children: c
      }
    )
  ] });
}, Re = ({ message: A, ...t }) => /* @__PURE__ */ e(FA, { ...t, children: /* @__PURE__ */ e(zA, { children: /* @__PURE__ */ e(WA, { icon: /* @__PURE__ */ e(Pt, {}), variant: "error", children: A }) }) }), Xe = ({
  helpText: A,
  fieldLabelId: t,
  noVerticalAlign: n = !0,
  unWrap: r = !1
}) => {
  const { enabled: a } = Yn();
  return a ? /* @__PURE__ */ e(at, { bodyContent: A, children: /* @__PURE__ */ v(z, { children: [
    !r && /* @__PURE__ */ e(
      "button",
      {
        "data-testid": `help-label-${t}`,
        "aria-label": t,
        onClick: (i) => i.preventDefault(),
        className: "pf-v5-c-form__group-label-help",
        children: /* @__PURE__ */ e(SA, { isInline: n, children: /* @__PURE__ */ e(ce, {}) })
      }
    ),
    r && /* @__PURE__ */ e(SA, { isInline: n, children: /* @__PURE__ */ e(ce, {}) })
  ] }) }) : null;
};
function sA(A) {
  if (!(typeof A > "u" || A instanceof RegExp))
    return typeof A == "object" ? A.value : A;
}
const Z = ({
  id: A,
  name: t,
  label: n,
  labelIcon: r,
  error: a,
  children: i,
  ...s
}) => /* @__PURE__ */ v(
  fe,
  {
    label: n || t,
    fieldId: A || t,
    labelIcon: r ? /* @__PURE__ */ e(Xe, { helpText: r, fieldLabelId: A || t }) : void 0,
    ...s,
    children: [
      i,
      a && /* @__PURE__ */ e(Re, { "data-testid": `${t}-helper`, message: a.message })
    ]
  }
), Vr = ({
  name: A,
  label: t,
  controller: n,
  labelIcon: r,
  ...a
}) => {
  const {
    control: i,
    formState: { errors: s }
  } = wA();
  return /* @__PURE__ */ e(
    Z,
    {
      name: A,
      label: t,
      isRequired: n.rules?.required === !0,
      error: s[A],
      labelIcon: r,
      children: /* @__PURE__ */ e(
        iA,
        {
          ...n,
          name: A,
          control: i,
          render: ({ field: l }) => {
            const d = !!n.rules?.required, c = sA(n.rules?.min), u = l.value ?? n.defaultValue, o = (h) => l.onChange(
              c !== void 0 ? Math.max(h, Number(c)) : h
            );
            return /* @__PURE__ */ e(
              it,
              {
                ...a,
                id: A,
                value: u,
                validated: s[A] ? N.error : N.default,
                required: d,
                min: Number(c),
                max: Number(n.rules?.max),
                onPlus: () => o(u + 1),
                onMinus: () => o(u - 1),
                onChange: (h) => {
                  const I = Number(h.currentTarget.value);
                  o(isNaN(I) ? n.defaultValue : I);
                }
              }
            );
          }
        }
      )
    }
  );
}, Xn = ({
  hasReveal: A = !0,
  innerRef: t,
  ...n
}) => {
  const { t: r } = S(), [a, i] = w(!0);
  return /* @__PURE__ */ v(DA, { children: [
    /* @__PURE__ */ e(RA, { isFill: !0, children: /* @__PURE__ */ e(
      EA,
      {
        ...n,
        type: a ? "password" : "text",
        ref: t
      }
    ) }),
    A && /* @__PURE__ */ e(
      X,
      {
        variant: "control",
        "aria-label": r("showPassword"),
        onClick: () => i(!a),
        children: a ? /* @__PURE__ */ e(Nt, {}) : /* @__PURE__ */ e(Vt, {})
      }
    )
  ] });
}, Ge = Rt(
  (A, t) => /* @__PURE__ */ e(Xn, { ...A, innerRef: t })
);
Ge.displayName = "PasswordInput";
const Fr = (A) => {
  const { labelIcon: t, ...n } = A, r = !!sA(A.rules?.required), a = A.defaultValue ?? "", { field: i, fieldState: s } = bA({
    ...A,
    defaultValue: a
  });
  return /* @__PURE__ */ v(
    Z,
    {
      name: A.name,
      label: A.label,
      labelIcon: t,
      isRequired: r,
      error: s.error,
      children: [
        /* @__PURE__ */ e(
          Ge,
          {
            isRequired: r,
            id: A.name,
            "data-testid": A.name,
            validated: s.error ? N.error : N.default,
            isDisabled: A.isDisabled,
            ...n,
            ...i
          }
        ),
        A.helperText && /* @__PURE__ */ e(FA, { children: /* @__PURE__ */ e(zA, { children: /* @__PURE__ */ e(WA, { children: A.helperText }) }) })
      ]
    }
  );
}, Gn = ({
  id: A,
  name: t,
  label: n,
  options: r,
  selectedOptions: a = [],
  controller: i,
  labelIcon: s,
  isDisabled: l,
  onSelect: d,
  ...c
}) => {
  const {
    control: u,
    formState: { errors: o }
  } = wA(), [h, I] = w(!1), B = sA(i.rules?.required) === !0;
  return /* @__PURE__ */ e(
    Z,
    {
      id: A,
      name: t,
      label: n,
      isRequired: B,
      error: R(o, t),
      labelIcon: s,
      children: /* @__PURE__ */ e(
        iA,
        {
          ...i,
          name: t,
          control: u,
          render: ({ field: { onChange: k, value: m } }) => /* @__PURE__ */ e(
            QA,
            {
              ...c,
              variant: "default",
              onClick: () => I(!h),
              onOpenChange: () => I(!1),
              selected: eA(r) ? r.filter(
                (g) => Array.isArray(m) ? m.includes(g.key) : m === g.key
              ).map((g) => g.value) : m,
              toggle: (g) => /* @__PURE__ */ e(
                gA,
                {
                  id: A || t,
                  ref: g,
                  onClick: () => I(!h),
                  isExpanded: h,
                  isFullWidth: !0,
                  status: R(o, t) ? UA.danger : void 0,
                  "aria-label": n,
                  isDisabled: l,
                  children: eA(r) ? r.find(
                    (Q) => Q.key === (Array.isArray(m) ? m[0] : m)
                  )?.value : m
                }
              ),
              onSelect: (g, Q) => {
                const E = Q?.toString(), y = Array.isArray(m) ? [E] : E;
                d ? d(y, k) : k(y), I(!1);
              },
              isOpen: h,
              children: /* @__PURE__ */ e(MA, { "data-testid": `select-${t}`, children: [...r, ...a].map((g) => /* @__PURE__ */ e(KA, { value: aA(g), children: Ae(g) ? g : g.value }, aA(g))) })
            }
          )
        }
      )
    }
  );
}, AA = (A) => Ae(A) ? A : A.value, Hn = ({
  id: A,
  name: t,
  label: n,
  options: r,
  selectedOptions: a = [],
  controller: i,
  labelIcon: s,
  placeholderText: l,
  onFilter: d,
  variant: c,
  ...u
}) => {
  const {
    control: o,
    formState: { errors: h }
  } = wA(), [I, B] = w(!1), [k, m] = w(""), [g, Q] = w(0), [E, y] = w([]), p = U(), M = sA(i.rules?.required) === !0, T = c === dA.typeaheadMulti, b = G(
    () => [
      ...r.filter(
        (C) => !a.map((f) => AA(f)).includes(AA(C))
      ),
      ...a
    ],
    [a, r]
  ), j = b.filter(
    (C) => AA(C).toLowerCase().startsWith(k.toLowerCase())
  ), V = (C, f) => {
    f.value.includes(C) ? (f.onChange(f.value.filter((x) => x !== C)), eA(r) && y(
      E.filter((x) => x.key !== C)
    )) : (f.onChange([...f.value, C]), eA(b) && y([
      ...E,
      b.find((x) => x.key === C)
    ]));
  }, J = (C, f) => {
    const x = j[g];
    switch (B(!0), C.key) {
      case "Enter": {
        C.preventDefault(), m(T ? "" : AA(x)), V(aA(x), f), B(!1), Q(0);
        break;
      }
      case "Tab":
      case "Escape": {
        B(!1), f.onChange(void 0);
        break;
      }
      case "Backspace": {
        c === dA.typeahead && f.onChange("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        C.preventDefault();
        let O = 0;
        C.key === "ArrowUp" && (g === 0 ? O = r.length - 1 : O = g - 1), C.key === "ArrowDown" && (g === r.length - 1 ? O = 0 : O = g + 1), Q(O);
        break;
      }
    }
  };
  return /* @__PURE__ */ e(
    Z,
    {
      id: A,
      name: t,
      label: n,
      isRequired: M,
      error: R(h, t),
      labelIcon: s,
      children: /* @__PURE__ */ e(
        iA,
        {
          ...i,
          name: t,
          control: o,
          render: ({ field: C }) => /* @__PURE__ */ e(
            QA,
            {
              ...u,
              onOpenChange: () => B(!1),
              selected: eA(b) ? b.filter(
                (f) => Array.isArray(C.value) ? C.value.includes(f.key) : C.value === f.key
              ).map((f) => f.value) : C.value,
              shouldFocusFirstItemOnOpen: !1,
              toggle: (f) => /* @__PURE__ */ e(
                gA,
                {
                  ref: f,
                  id: A || t,
                  variant: "typeahead",
                  onClick: () => {
                    B(!I), p.current?.focus();
                  },
                  isExpanded: I,
                  isFullWidth: !0,
                  status: R(h, t) ? UA.danger : void 0,
                  children: /* @__PURE__ */ v(Be, { isPlain: !0, children: [
                    /* @__PURE__ */ e(
                      De,
                      {
                        placeholder: l,
                        value: c === dA.typeahead && C.value ? eA(b) ? b.find(
                          (x) => x.key === (Array.isArray(C.value) ? C.value[0] : C.value)
                        )?.value : C.value : k,
                        onClick: () => B(!I),
                        onChange: (x, O) => {
                          m(O), d?.(O);
                        },
                        onKeyDown: (x) => J(x, C),
                        autoComplete: "off",
                        innerRef: p,
                        role: "combobox",
                        isExpanded: I,
                        "aria-controls": "select-typeahead-listbox",
                        children: c === dA.typeaheadMulti && Array.isArray(C.value) && /* @__PURE__ */ e(ZA, { "aria-label": "Current selections", children: C.value.map(
                          (x, O) => /* @__PURE__ */ e(
                            qA,
                            {
                              onClick: (lA) => {
                                lA.stopPropagation(), C.onChange(
                                  C.value.filter(
                                    (H) => H !== aA(x)
                                  )
                                );
                              },
                              children: eA(b) ? [
                                ...b,
                                ...E
                              ].find((lA) => x === lA.key)?.value : AA(x)
                            },
                            O
                          )
                        ) })
                      }
                    ),
                    /* @__PURE__ */ e(Ee, { children: (!!k || C.value) && /* @__PURE__ */ e(
                      X,
                      {
                        variant: "plain",
                        onClick: () => {
                          m(""), C.onChange(T ? [] : ""), p?.current?.focus();
                        },
                        "aria-label": "Clear input value",
                        children: /* @__PURE__ */ e(Te, { "aria-hidden": !0 })
                      }
                    ) })
                  ] })
                }
              ),
              onSelect: (f, x) => {
                f?.stopPropagation();
                const O = x?.toString();
                T && Array.isArray(C.value) ? (m(""), V(O || "", C)) : (C.onChange(Array.isArray(C.value) ? [O] : O), B(!1));
              },
              isOpen: I,
              children: /* @__PURE__ */ e(MA, { children: j.map((f, x) => /* @__PURE__ */ e(
                KA,
                {
                  value: aA(f),
                  isFocused: g === x,
                  isActive: C.value.includes(AA(f)),
                  children: AA(f)
                },
                aA(f)
              )) })
            }
          )
        }
      )
    }
  );
};
var dA = /* @__PURE__ */ ((A) => (A.single = "single", A.typeahead = "typeahead", A.typeaheadMulti = "typeaheadMulti", A))(dA || {});
const eA = (A) => typeof A[0] != "string", Ae = (A) => typeof A == "string", aA = (A) => Ae(A) ? A : A.key, Pn = ({
  variant: A = "single",
  ...t
}) => A === "single" ? /* @__PURE__ */ e(Gn, { ...t }) : /* @__PURE__ */ e(Hn, { ...t, variant: A }), HA = (A) => A?.includes("${"), PA = (A) => A.substring(2, A.length - 1), tA = (A, t, n, r) => {
  const a = t || n, i = HA(a) ? PA(a) : a, s = r ? `${r}.${i}` : i;
  return A(s || "");
}, NA = (A, t) => tA(A, t.displayName, t.name), Nn = ["username", "firstName", "lastName", "email"], He = (A) => A && Nn.includes(A), q = (A) => `${He(A) ? "" : "attributes."}${A?.replaceAll(
  ".",
  "🍺"
)}`, zr = (A) => A.replaceAll(".", "🍺"), Vn = (A) => A.replaceAll("🍺", ".");
function Wr(A, t, n) {
  (A.responseData.errors !== void 0 ? A.responseData.errors : [A.responseData]).forEach((r) => {
    const a = Object.assign(
      {},
      r.params?.map((i) => HA(i?.toString()) ? n(PA(i)) : i)
    );
    t(q(r.field), {
      message: n(
        HA(r.errorMessage) ? PA(r.errorMessage) : r.errorMessage,
        {
          /* eslint-disable @typescript-eslint/no-misused-spread */
          ...a,
          defaultValue: r.errorMessage || r.field
        }
      ),
      type: "server"
    });
  });
}
function xA({
  required: A
}) {
  return A;
}
function Kr(A) {
  if (typeof A != "object" || A === null || !("responseData" in A))
    return !1;
  const { responseData: t } = A;
  return ue(t) ? !0 : typeof t != "object" || t === null || !("errors" in t) || !Array.isArray(t.errors) ? !1 : t.errors.every(ue);
}
function ue(A) {
  return !(typeof A != "object" || A === null || !("field" in A) || typeof A.field != "string" || !("errorMessage" in A) || typeof A.errorMessage != "string");
}
const Ur = ({
  labelOn: A,
  stringify: t,
  defaultValue: n,
  labelIcon: r,
  ...a
}) => {
  const s = n ?? (t ? "false" : !1), { control: l } = wA();
  return /* @__PURE__ */ e(
    Z,
    {
      hasNoPaddingTop: !0,
      name: a.name,
      isRequired: a.rules?.required === !0,
      label: a.label,
      labelIcon: r,
      children: /* @__PURE__ */ e(
        iA,
        {
          control: l,
          name: a.name,
          defaultValue: s,
          render: ({ field: { onChange: d, value: c } }) => /* @__PURE__ */ e(
            st,
            {
              ...a,
              id: a.name,
              "data-testid": Vn(a.name),
              label: A,
              isChecked: t ? c === "true" : c,
              onChange: (u, o) => {
                const h = t ? o.toString() : o;
                a.onChange?.(u, o), d(h);
              }
            }
          )
        }
      )
    }
  );
}, Zr = (A) => {
  const t = !!A.rules?.required, n = A.defaultValue ?? "", { field: r, fieldState: a } = bA({
    ...A,
    defaultValue: n
  });
  return /* @__PURE__ */ e(
    Z,
    {
      isRequired: t,
      label: A.label,
      labelIcon: A.labelIcon,
      name: A.name,
      error: a.error,
      children: /* @__PURE__ */ e(
        Qe,
        {
          isRequired: t,
          id: A.name,
          "data-testid": A.name,
          validated: a.error ? N.error : N.default,
          isDisabled: A.isDisabled,
          ...A,
          ...r
        }
      )
    }
  );
}, qr = (A) => {
  const { labelIcon: t, helperText: n, ...r } = A, a = !!sA(A.rules?.required), i = A.defaultValue ?? "", { field: s, fieldState: l } = bA({
    ...A,
    defaultValue: i
  });
  return /* @__PURE__ */ v(
    Z,
    {
      name: A.name,
      label: A.label,
      labelIcon: t,
      isRequired: a,
      error: l.error,
      children: [
        /* @__PURE__ */ e(
          EA,
          {
            isRequired: a,
            id: A.name,
            "data-testid": A["data-testid"] || A.name,
            validated: l.error ? N.error : N.default,
            isDisabled: A.isDisabled,
            ...r,
            ...s
          }
        ),
        n && /* @__PURE__ */ e(FA, { children: /* @__PURE__ */ e(zA, { children: /* @__PURE__ */ e(WA, { children: n }) }) })
      ]
    }
  );
}, Fn = Qe, _r = (A) => {
  const { labelIcon: t, ...n } = A, r = !!sA(A.rules?.required), a = A.defaultValue ?? "", { t: i } = S(), [s, l] = w(""), { field: d, fieldState: c } = bA({
    ...A,
    defaultValue: a
  });
  return /* @__PURE__ */ e(
    Z,
    {
      name: A.name,
      label: A.label,
      labelIcon: t,
      isRequired: r,
      error: c.error,
      children: /* @__PURE__ */ e(
        lt,
        {
          isRequired: r,
          "data-testid": A["data-testid"] || A.name,
          filename: s,
          browseButtonText: i("browse"),
          validated: c.error ? N.error : N.default,
          hideDefaultPreview: !0,
          isDisabled: A.isDisabled,
          type: "text",
          onFileInputChange: (u, o) => {
            d.onChange(o), l(o.name);
          },
          onClearClick: () => {
            d.onChange(null), l("");
          },
          ...n,
          ...d
        }
      )
    }
  );
}, $r = ({ icon: A }) => {
  const t = zn(A);
  return /* @__PURE__ */ e(SA, { size: "lg", children: /* @__PURE__ */ e(t, { alt: A }) });
};
function zn(A) {
  switch (A) {
    case "github":
      return nn;
    case "facebook":
      return tn;
    case "gitlab":
      return en;
    case "google":
      return An;
    case "linkedin":
    case "linkedin-openid-connect":
      return $t;
    case "openshift-v4":
      return _t;
    case "stackoverflow":
      return qt;
    case "twitter":
      return Zt;
    case "microsoft":
      return Ut;
    case "bitbucket":
      return Kt;
    case "instagram":
      return Wt;
    case "paypal":
      return zt;
    default:
      return Ft;
  }
}
const Wn = "_title_jpdeu_3", Kn = {
  title: Wn
}, Pe = ({
  id: A,
  title: t,
  headingLevel: n = "h1",
  size: r = "xl",
  ...a
}) => /* @__PURE__ */ e(
  ot,
  {
    headingLevel: n,
    size: r,
    className: Kn.title,
    id: A,
    tabIndex: 0,
    ...a,
    children: t
  }
), Un = ({
  title: A,
  children: t,
  scrollId: n,
  className: r
}) => {
  const a = be();
  return /* @__PURE__ */ v(ct, { id: a, className: r, isFlat: !0, children: [
    /* @__PURE__ */ e(dt, { className: "kc-form-panel__header", children: /* @__PURE__ */ e(ut, { tabIndex: 0, children: /* @__PURE__ */ e(Pe, { id: n, title: A }) }) }),
    /* @__PURE__ */ e(gt, { className: "kc-form-panel__body", children: t })
  ] });
}, Zn = (A) => {
  const { title: t, children: n, scrollId: r, ...a } = A;
  return /* @__PURE__ */ e("section", { ...a, style: { marginTop: "var(--pf-v5-global--spacer--lg)" }, children: /* @__PURE__ */ v(z, { children: [
    /* @__PURE__ */ e(Pe, { id: r, title: t }),
    n
  ] }) });
}, qn = "_panel_1kfdo_1", _n = "_sticky_1kfdo_9", ge = {
  panel: qn,
  sticky: _n
}, $n = "kc-main-content-page-container", me = (A) => A.replace(/\s+/g, "-"), Ar = ({
  label: A,
  sections: t,
  borders: n = !1,
  ...r
}) => {
  const a = G(
    () => t.filter(({ isHidden: i }) => !i),
    [t]
  );
  return /* @__PURE__ */ v(mt, { hasGutter: !0, ...r, children: [
    /* @__PURE__ */ e(se, { md: 8, sm: 12, children: a.map(({ title: i, panel: s }) => {
      const l = me(i.toLowerCase());
      return /* @__PURE__ */ e(xe, { children: n ? /* @__PURE__ */ e(
        Un,
        {
          scrollId: l,
          title: i,
          className: ge.panel,
          children: s
        }
      ) : /* @__PURE__ */ e(Zn, { scrollId: l, title: i, children: s }) }, i);
    }) }),
    /* @__PURE__ */ e(se, { md: 4, sm: 12, order: { default: "-1", md: "1" }, children: /* @__PURE__ */ e(Ct, { className: ge.sticky, children: /* @__PURE__ */ e(
      It,
      {
        isVertical: !0,
        scrollableSelector: `#${$n}`,
        label: A,
        offset: 100,
        children: a.map(({ title: i }) => {
          const s = me(i.toLowerCase());
          return /* @__PURE__ */ e(
            ht,
            {
              onClick: () => {
                const l = document.getElementById(s);
                l && l.scrollIntoView({
                  behavior: "smooth",
                  block: "start"
                });
              },
              "data-testid": `jump-link-${s}`,
              children: i
            },
            i
          );
        })
      }
    ) }) })
  ] });
}, er = (A, t, n) => (A.isValid || n) && (A.isDirty || t) && !A.isLoading && !A.isValidating && !A.isSubmitting, Aa = ({
  formState: A,
  isDisabled: t = !1,
  allowInvalid: n = !1,
  allowNonDirty: r = !1,
  children: a,
  ...i
}) => /* @__PURE__ */ e(
  X,
  {
    variant: "primary",
    isDisabled: A && !er(A, r, n) || t,
    ...i,
    type: "submit",
    children: a
  }
), tr = (A) => {
  try {
    return new Intl.DisplayNames([A], { type: "language" }).of(A);
  } catch {
    return A;
  }
}, nr = ({
  t: A,
  form: t,
  supportedLocales: n,
  currentLocale: r
}) => {
  const a = G(
    () => n.map((i) => ({
      key: i,
      value: A(`locale_${i}`, tr(i) ?? i)
    })).sort((i, s) => i.value.localeCompare(s.value, r)),
    [n, r, A]
  );
  return a.length ? /* @__PURE__ */ e(on, { ...t, children: /* @__PURE__ */ e(
    Pn,
    {
      "data-testid": "locale-select",
      name: "attributes.locale",
      label: A("selectALocale"),
      controller: { defaultValue: "" },
      options: [{ key: "", value: A("defaultLocale") }, ...a],
      variant: a.length >= 10 ? "typeahead" : "single"
    }
  ) }) : null;
}, mA = ({
  t: A,
  form: t,
  attribute: n,
  renderer: r,
  children: a
}) => {
  const i = tA(
    A,
    n.annotations?.inputHelperTextBefore
  ), {
    formState: { errors: s }
  } = t, l = r?.(n), d = R(s, q(n.name));
  return /* @__PURE__ */ v(
    fe,
    {
      label: NA(A, n) || "",
      fieldId: n.name,
      isRequired: xA(n),
      labelIcon: i ? /* @__PURE__ */ e(Xe, { helpText: i, fieldLabelId: n.name }) : void 0,
      children: [
        l ? /* @__PURE__ */ v(DA, { children: [
          a,
          l
        ] }) : a,
        d && /* @__PURE__ */ e(
          Re,
          {
            "data-testid": `${n.name}-helper`,
            message: d.message
          }
        )
      ]
    },
    n.name
  );
}, rr = ({
  t: A,
  form: t,
  attribute: n,
  renderer: r,
  ...a
}) => /* @__PURE__ */ e(mA, { t: A, form: t, attribute: n, renderer: r, children: /* @__PURE__ */ e(
  ar,
  {
    t: A,
    form: t,
    "aria-label": NA(A, n),
    name: q(n.name),
    addButtonLabel: A("addMultivaluedLabel", {
      fieldLabel: NA(A, n)
    }),
    ...a
  }
) }), ar = ({
  t: A,
  name: t,
  inputType: n,
  form: r,
  addButtonLabel: a,
  isDisabled: i = !1,
  defaultValue: s,
  id: l,
  ...d
}) => {
  const { register: c, setValue: u, control: o } = r, h = cn({
    name: t,
    control: o,
    defaultValue: s || ""
  }), I = G(() => Array.isArray(h) && h.length !== 0 ? h : s || [""], [h]), B = (E) => {
    g([...I.slice(0, E), ...I.slice(E + 1)]);
  }, k = () => {
    g([...I, ""]);
  }, m = (E, y) => {
    g([...I.slice(0, E), y, ...I.slice(E + 1)]);
  }, g = (E) => {
    const y = E.flatMap((p) => p);
    u(t, y, {
      shouldDirty: !0
    });
  }, Q = n.startsWith("html") ? n.substring(6) : "text";
  return nA(() => {
    c(t);
  }, [c]), /* @__PURE__ */ e("div", { id: l, children: I.map((E, y) => /* @__PURE__ */ v(xe, { children: [
    /* @__PURE__ */ v(DA, { children: [
      /* @__PURE__ */ e(RA, { isFill: !0, children: /* @__PURE__ */ e(
        EA,
        {
          "data-testid": t + y,
          onChange: (p, M) => m(y, M),
          name: `${t}.${y}.value`,
          value: E,
          isDisabled: i,
          type: Q,
          ...d
        }
      ) }),
      /* @__PURE__ */ e(RA, { children: /* @__PURE__ */ e(
        X,
        {
          "data-testid": "remove" + y,
          variant: fA.link,
          onClick: () => B(y),
          tabIndex: -1,
          "aria-label": A("remove"),
          isDisabled: I.length === 1 || i,
          children: /* @__PURE__ */ e(rn, {})
        }
      ) })
    ] }),
    y === I.length - 1 && /* @__PURE__ */ v(
      X,
      {
        variant: fA.link,
        onClick: k,
        tabIndex: -1,
        "aria-label": A("add"),
        "data-testid": "addValue",
        isDisabled: !E || i,
        children: [
          /* @__PURE__ */ e(Ye, {}),
          " ",
          A(a || "add")
        ]
      }
    )
  ] }, y)) });
}, Ce = (A) => {
  const { form: t, inputType: n, attribute: r } = A, a = xA(r), i = n.startsWith("multiselect"), s = i ? pt : vt, l = r.validators?.options?.options || [], d = r.annotations?.inputOptionLabels || {}, c = r.annotations?.inputOptionLabelsI18nPrefix;
  return /* @__PURE__ */ e(mA, { ...A, children: /* @__PURE__ */ e(
    iA,
    {
      name: q(r.name),
      control: t.control,
      defaultValue: "",
      render: ({ field: u }) => /* @__PURE__ */ e(z, { children: l.map((o) => /* @__PURE__ */ e(
        s,
        {
          id: o,
          "data-testid": o,
          label: tA(A.t, d[o], o, c),
          value: o,
          isChecked: u.value.includes(o),
          onChange: () => {
            i ? u.value.includes(o) ? u.onChange(
              u.value.filter((h) => h !== o)
            ) : u.onChange([...u.value, o]) : u.onChange([o]);
          },
          readOnly: r.readOnly,
          isRequired: a
        },
        o
      )) })
    }
  ) });
}, ir = ({
  toggleId: A,
  onToggle: t,
  onSelect: n,
  selections: r,
  isOpen: a,
  menuAppendTo: i,
  direction: s,
  width: l,
  maxHeight: d,
  toggleIcon: c,
  className: u,
  isDisabled: o,
  children: h,
  ...I
}) => {
  const [B, k] = w(!1), m = U(), g = () => {
    k(!B), t(!B);
  }, Q = () => i === "parent" && m.current?.parentElement || "inline", E = Oe.toArray(
    h
  );
  return /* @__PURE__ */ e(
    QA,
    {
      ref: m,
      maxMenuHeight: BA(d),
      isScrollable: !0,
      popperProps: {
        appendTo: Q(),
        direction: s,
        width: BA(l)
      },
      ...I,
      onClick: g,
      onOpenChange: (y) => {
        y !== B && g();
      },
      selected: r,
      onSelect: (y, p) => {
        n?.(p || ""), g();
      },
      toggle: (y) => /* @__PURE__ */ e(
        gA,
        {
          id: A,
          ref: y,
          className: u,
          onClick: g,
          isExpanded: a,
          "aria-label": I["aria-label"],
          icon: c,
          isDisabled: o,
          isFullWidth: !0,
          children: E.find((p) => p.props.value === r)?.props.children || r || I["aria-label"]
        }
      ),
      isOpen: a,
      children: /* @__PURE__ */ e(MA, { children: h })
    }
  );
}, sr = ({
  toggleId: A,
  onSelect: t,
  onToggle: n,
  onFilter: r,
  variant: a,
  validated: i,
  placeholderText: s,
  maxHeight: l,
  width: d,
  toggleIcon: c,
  direction: u,
  selections: o,
  typeAheadAriaLabel: h,
  chipGroupComponent: I,
  chipGroupProps: B,
  footer: k,
  isDisabled: m,
  children: g,
  ...Q
}) => {
  const [E, y] = w(""), [p, M] = w(0), T = U(), b = Oe.toArray(
    g
  ), j = () => {
    n?.(!Q.isOpen);
  }, V = (J) => {
    const C = b[p];
    switch (n?.(!0), J.key) {
      case "Enter": {
        J.preventDefault(), a !== K.typeaheadMulti ? y(C.props.value) : y(""), t?.(C.props.value), n?.(!1), M(0);
        break;
      }
      case "Escape": {
        n?.(!1);
        break;
      }
      case "Backspace": {
        a === K.typeahead && t?.("");
        break;
      }
      case "ArrowUp":
      case "ArrowDown": {
        J.preventDefault();
        let f = 0;
        J.key === "ArrowUp" && (p === 0 ? f = b.length - 1 : f = p - 1), J.key === "ArrowDown" && (p === b.length - 1 ? f = 0 : f = p + 1), M(f);
        break;
      }
    }
  };
  return /* @__PURE__ */ v(
    QA,
    {
      ...Q,
      onClick: j,
      onOpenChange: (J) => n?.(J),
      onSelect: (J, C) => {
        t?.(C || ""), r?.(""), y("");
      },
      maxMenuHeight: BA(l),
      popperProps: { direction: u, width: BA(d) },
      toggle: (J) => /* @__PURE__ */ e(
        gA,
        {
          ref: J,
          id: A,
          variant: "typeahead",
          onClick: () => n?.(!0),
          icon: c,
          isDisabled: m,
          isExpanded: Q.isOpen,
          isFullWidth: !0,
          status: i === "error" ? UA.danger : void 0,
          children: /* @__PURE__ */ v(Be, { isPlain: !0, children: [
            /* @__PURE__ */ e(
              De,
              {
                placeholder: s,
                value: a === K.typeahead && o ? o : E,
                onClick: j,
                onChange: (C, f) => {
                  y(f), r?.(f);
                },
                onKeyDown: (C) => V(C),
                autoComplete: "off",
                innerRef: T,
                role: "combobox",
                isExpanded: Q.isOpen,
                "aria-controls": "select-typeahead-listbox",
                "aria-label": h,
                children: a === K.typeaheadMulti && Array.isArray(o) && (I || /* @__PURE__ */ e(ZA, { ...B, children: o.map((C, f) => /* @__PURE__ */ e(
                  qA,
                  {
                    onClick: (x) => {
                      x.stopPropagation(), t?.(C);
                    },
                    children: C
                  },
                  f
                )) }))
              }
            ),
            /* @__PURE__ */ e(Ee, { children: !!E && /* @__PURE__ */ e(
              X,
              {
                variant: "plain",
                onClick: () => {
                  t?.(""), y(""), r?.(""), T?.current?.focus();
                },
                "aria-label": "Clear input value",
                children: /* @__PURE__ */ e(Te, { "aria-hidden": !0 })
              }
            ) })
          ] })
        }
      ),
      children: [
        /* @__PURE__ */ e(MA, { children: g }),
        k && /* @__PURE__ */ e(yt, { children: k })
      ]
    }
  );
};
var K = /* @__PURE__ */ ((A) => (A.single = "single", A.typeahead = "typeahead", A.typeaheadMulti = "typeaheadMulti", A))(K || {});
const BA = (A) => typeof A == "number" ? A + "px" : A, lr = ({
  variant: A = "single",
  ...t
}) => A === "single" ? /* @__PURE__ */ e(ir, { ...t }) : /* @__PURE__ */ e(sr, { ...t, variant: A }), Ie = (A) => {
  const { t, form: n, inputType: r, attribute: a } = A, [i, s] = w(!1), [l, d] = w(""), c = r === "multiselect", u = (m, g) => {
    c ? g.value.includes(m) ? g.onChange(g.value.filter((Q) => Q !== m)) : Array.isArray(g.value) ? g.onChange([...g.value, m]) : g.onChange([m]) : g.onChange(m === g.value ? "" : m);
  }, o = a.validators?.options?.options || [], h = a.annotations?.inputOptionLabels || {}, I = a.annotations?.inputOptionLabelsI18nPrefix, B = (m) => tA(A.t, h[m], m, I), k = (m) => o.filter(
    (g) => B(g).toLowerCase().includes(l.toLowerCase())
  ).map((g) => /* @__PURE__ */ e(
    KA,
    {
      selected: m === g,
      value: g,
      children: B(g)
    },
    g
  ));
  return /* @__PURE__ */ e(mA, { ...A, children: /* @__PURE__ */ e(
    iA,
    {
      name: q(a.name),
      defaultValue: "",
      control: n.control,
      render: ({ field: m }) => /* @__PURE__ */ e(
        lr,
        {
          toggleId: a.name,
          onToggle: (g) => s(g),
          onClear: () => u("", m),
          onSelect: (g) => {
            const Q = g.toString();
            u(Q, m), Array.isArray(m.value) || s(!1);
          },
          selections: c && Array.isArray(m.value) ? m.value.map((g) => B(g)) : B(m.value),
          variant: c ? K.typeaheadMulti : o.length >= 10 ? K.typeahead : K.single,
          "aria-label": t("selectOne"),
          isOpen: i,
          isDisabled: a.readOnly,
          onFilter: (g) => (d(g), k(m.value)),
          children: k(m.value)
        }
      )
    }
  ) });
}, or = (A) => {
  const { form: t, attribute: n } = A, r = xA(n);
  return /* @__PURE__ */ e(mA, { ...A, children: /* @__PURE__ */ e(
    Fn,
    {
      id: n.name,
      "data-testid": n.name,
      ...t.register(q(n.name)),
      cols: n.annotations?.inputTypeCols,
      rows: n.annotations?.inputTypeRows,
      readOnly: n.readOnly,
      isRequired: r
    }
  ) });
}, P = (A) => {
  const { form: t, inputType: n, attribute: r } = A, a = xA(r), i = n.startsWith("html") ? n.substring(6) : "text";
  return /* @__PURE__ */ e(mA, { ...A, children: /* @__PURE__ */ e(
    EA,
    {
      id: r.name,
      "data-testid": r.name,
      type: i,
      placeholder: r.readOnly ? "" : tA(
        A.t,
        r.annotations?.inputTypePlaceholder,
        "",
        r.annotations?.inputOptionLabelsI18nPrefix
      ),
      isDisabled: r.readOnly,
      isRequired: a,
      ...t.register(q(r.name))
    }
  ) });
}, VA = {
  text: P,
  textarea: or,
  select: Ie,
  "select-radiobuttons": Ce,
  multiselect: Ie,
  "multiselect-checkboxes": Ce,
  "html5-email": P,
  "html5-tel": P,
  "html5-url": P,
  "html5-number": P,
  "html5-range": P,
  "html5-datetime-local": P,
  "html5-date": P,
  "html5-month": P,
  "html5-time": P,
  "multi-input": rr
}, ea = ({
  t: A,
  form: t,
  userProfileMetadata: n,
  supportedLocales: r,
  currentLocale: a,
  hideReadOnly: i = !1,
  renderer: s
}) => {
  const l = G(() => {
    if (!n.attributes)
      return [];
    const d = i ? n.attributes.filter(({ readOnly: c }) => !c) : n.attributes;
    return [
      // Insert an empty group for attributes without a group.
      { name: void 0 },
      ...n.groups ?? []
    ].map((c) => ({
      group: c,
      attributes: d.filter(
        (u) => u.group === c.name
      )
    }));
  }, [
    i,
    n.groups,
    n.attributes
  ]);
  return l.length === 0 ? null : /* @__PURE__ */ e(
    Ar,
    {
      label: A("jumpToSection"),
      sections: l.filter((d) => d.attributes.length > 0).map(({ group: d, attributes: c }) => ({
        title: tA(A, d.displayHeader, d.name) || A("general"),
        panel: /* @__PURE__ */ v("div", { className: "pf-v5-c-form", children: [
          d.displayDescription && /* @__PURE__ */ e(jA, { className: "pf-v5-u-pb-lg", children: tA(A, d.displayDescription, "") }),
          c.map((u) => /* @__PURE__ */ e(
            cr,
            {
              t: A,
              form: t,
              supportedLocales: r,
              currentLocale: a,
              renderer: s,
              attribute: u
            },
            u.name
          ))
        ] })
      }))
    }
  );
}, cr = ({
  t: A,
  form: t,
  renderer: n,
  supportedLocales: r,
  currentLocale: a,
  attribute: i
}) => {
  const s = t.watch(
    q(i.name)
  ), l = G(() => ur(i), [i]), d = i.multivalued || mr(s) && i.annotations?.inputType === void 0 ? VA["multi-input"] : VA[l];
  return i.name === "locale" ? /* @__PURE__ */ e(
    nr,
    {
      form: t,
      supportedLocales: r,
      currentLocale: a,
      t: A,
      attribute: i
    }
  ) : /* @__PURE__ */ e(
    d,
    {
      t: A,
      form: t,
      inputType: l,
      attribute: i,
      renderer: n
    }
  );
}, dr = "text";
function ur(A) {
  if (He(A.name))
    return "text";
  const t = A.annotations?.inputType;
  return gr(t) ? t : dr;
}
const gr = (A) => typeof A == "string" && A in VA, mr = (A) => Array.isArray(A) && A.length > 1, Cr = ({
  className: A = "",
  border: t,
  size: n = "md"
}) => /* @__PURE__ */ v(
  "svg",
  {
    className: gn(
      pA.avatar,
      pA.modifiers[n],
      t === "light" && pA.modifiers.light,
      t === "dark" && pA.modifiers.dark,
      A
    ),
    enableBackground: "new 0 0 36 36",
    version: "1.1",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e(
        "circle",
        {
          style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
          cx: "18",
          cy: "18.5",
          r: "18"
        }
      ),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e(
        "filter",
        {
          id: "b",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          filterUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ e("feColorMatrix", { values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0" })
        }
      ) }),
      /* @__PURE__ */ e(
        "mask",
        {
          id: "a",
          x: "5.2",
          y: "7.2",
          width: "25.6",
          height: "53.6",
          maskUnits: "userSpaceOnUse",
          children: /* @__PURE__ */ e("g", { style: { filter: 'url("#b")' }, children: /* @__PURE__ */ e(
            "circle",
            {
              style: { fillRule: "evenodd", clipRule: "evenodd", fill: "#FFFFFF" },
              cx: "18",
              cy: "18.5",
              r: "18"
            }
          ) })
        }
      ),
      /* @__PURE__ */ e("g", { style: { filter: 'url("#a")' }, children: /* @__PURE__ */ v("g", { transform: "translate(5.04 6.88)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m22.6 18.1c-1.1-1.4-2.3-2.2-3.5-2.6s-1.8-0.6-6.3-0.6-6.1 0.7-6.1 0.7 0 0 0 0c-1.2 0.4-2.4 1.2-3.4 2.6-2.3 2.8-3.2 12.3-3.2 14.8 0 3.2 0.4 12.3 0.6 15.4 0 0-0.4 5.5 4 5.5l-0.3-6.3-0.4-3.5 0.2-0.9c0.9 0.4 3.6 1.2 8.6 1.2 5.3 0 8-0.9 8.8-1.3l0.2 1-0.2 3.6-0.3 6.3c3 0.1 3.7-3 3.8-4.4s0.6-12.6 0.6-16.5c0.1-2.6-0.8-12.1-3.1-15z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m22.5 26c-0.1-2.1-1.5-2.8-4.8-2.8l2.2 9.6s1.8-1.7 3-1.8c0 0-0.4-4.6-0.4-5z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#BBBBBB"
            },
            d: "m12.7 13.2c-3.5 0-6.4-2.9-6.4-6.4s2.9-6.4 6.4-6.4 6.4 2.9 6.4 6.4-2.8 6.4-6.4 6.4z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.08,
              fillRule: "evenodd",
              clipRule: "evenodd",
              fill: "#231F20"
            },
            d: "m9.4 6.8c0-3 2.1-5.5 4.9-6.3-0.5-0.1-1-0.2-1.6-0.2-3.5 0-6.4 2.9-6.4 6.4s2.9 6.4 6.4 6.4c0.6 0 1.1-0.1 1.6-0.2-2.8-0.6-4.9-3.1-4.9-6.1z"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            style: {
              opacity: 0.1,
              fillRule: "evenodd",
              clipRule: "evenodd"
            },
            d: "m8.3 22.4c-2 0.4-2.9 1.4-3.1 3.5l-0.6 18.6s1.7 0.7 3.6 0.9l0.1-23z"
          }
        )
      ] }) })
    ]
  }
), he = ({
  isKebab: A = !1,
  title: t,
  dropDownItems: n,
  ...r
}) => {
  const [a, i] = w(!1);
  return /* @__PURE__ */ e(
    ft,
    {
      ...r,
      popperProps: {
        position: "right"
      },
      onOpenChange: (s) => i(s),
      toggle: (s) => /* @__PURE__ */ e(
        gA,
        {
          "data-testid": `${r["data-testid"]}-toggle`,
          ref: s,
          onClick: () => i(!a),
          isExpanded: a,
          variant: A ? "plain" : "default",
          children: A ? /* @__PURE__ */ e(an, {}) : t
        }
      ),
      isOpen: a,
      children: /* @__PURE__ */ e(Bt, { children: n })
    }
  );
};
function Ir(A, t) {
  if (!A)
    return t("unknownUser");
  const n = A.given_name, r = A.family_name, a = A.preferred_username;
  return n && r ? t("fullName", { givenName: n, familyName: r }) : n || r || a || t("unknownUser");
}
const ta = ({
  keycloak: A,
  brand: { src: t, alt: n, className: r, href: a, realmDisplayNameHtml: i, ...s },
  avatar: l,
  features: {
    hasLogout: d = !0,
    hasManageAccount: c = !0,
    hasUsername: u = !0
  } = {},
  kebabDropdownItems: o,
  dropdownItems: h = [],
  toolbarItems: I,
  toolbar: B,
  ...k
}) => {
  const { t: m } = S(), g = [];
  c && g.push(
    /* @__PURE__ */ e(
      le,
      {
        onClick: () => A.accountManagement(),
        children: m("manageAccount")
      },
      "manageAccount"
    )
  ), d && g.push(
    /* @__PURE__ */ e(le, { onClick: () => A.logout(), children: m("signOut") }, "signOut")
  );
  const Q = A.idTokenParsed?.picture;
  return /* @__PURE__ */ v(Dt, { ...k, children: [
    /* @__PURE__ */ e(Et, { ...s, children: /* @__PURE__ */ v("div", { style: { display: "flex", alignItems: "center" }, children: [
      /* @__PURE__ */ e("a", { href: a, children: /* @__PURE__ */ e("img", { src: t, alt: n, className: r }) }),
      /* @__PURE__ */ e(
        "span",
        {
          style: { fontSize: "16px", color: "#ffffff", textDecoration: "none" },
          dangerouslySetInnerHTML: { __html: i || "" }
        }
      )
    ] }) }),
    /* @__PURE__ */ v(Qt, { children: [
      B,
      /* @__PURE__ */ e(yA, { children: /* @__PURE__ */ v(XA, { children: [
        I?.map((E, y) => /* @__PURE__ */ e(F, { align: { default: "alignRight" }, children: E }, y)),
        /* @__PURE__ */ e(
          F,
          {
            visibility: {
              default: "hidden",
              md: "visible"
            },
            className: "user-options-dropdown",
            children: /* @__PURE__ */ e(
              he,
              {
                "data-testid": "options",
                dropDownItems: [...h, g],
                title: u ? Ir(A.idTokenParsed, m) : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          F,
          {
            align: { default: "alignLeft" },
            visibility: {
              md: "hidden"
            },
            children: /* @__PURE__ */ e(
              he,
              {
                "data-testid": "options-kebab",
                isKebab: !0,
                dropDownItems: [
                  ...o || h,
                  g
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ e(
          F,
          {
            variant: "overflow-menu",
            align: { default: "alignRight" },
            className: "pf-v5-u-m-0-on-lg",
            children: Q || l?.src ? /* @__PURE__ */ e(Mt, { src: Q, alt: m("avatar"), ...l }) : /* @__PURE__ */ e(Cr, { ...l })
          }
        )
      ] }) })
    ] })
  ] });
}, Ne = _A("ErrorBoundaryContext", void 0), Ve = () => $A(Ne);
class na extends Xt {
  state = {};
  static getDerivedStateFromError = (t) => ({ error: t });
  showBoundary = (t) => {
    this.setState({ error: t });
  };
  render() {
    return /* @__PURE__ */ e(
      Ne.Provider,
      {
        value: { error: this.state.error, showBoundary: this.showBoundary },
        children: this.props.children
      }
    );
  }
}
const ra = ({ children: A, fallback: t }) => {
  const { error: n } = Ve();
  return n ? /* @__PURE__ */ e(t, { error: n }) : A;
};
function hr(A, t, n) {
  const { showBoundary: r } = Ve();
  nA(() => {
    const a = new AbortController(), { signal: i } = a;
    return A().then((s) => {
      i.aborted || t(s);
    }).catch((s) => {
      console.error(s), i.aborted || r(s);
    }), () => a.abort();
  }, n);
}
const pr = () => {
  const { t: A } = S();
  return /* @__PURE__ */ e(wt, { children: /* @__PURE__ */ e(bt, { "aria-label": A("spinnerLoading") }) });
}, vr = ({
  message: A,
  instructions: t,
  onPrimaryAction: n,
  hasIcon: r = !0,
  isSearchVariant: a,
  primaryActionText: i,
  secondaryActions: s,
  icon: l,
  isDisabled: d = !1,
  children: c
}) => /* @__PURE__ */ v(xt, { "data-testid": "empty-state", variant: "lg", children: [
  r && a ? /* @__PURE__ */ e(oe, { icon: sn }) : r && /* @__PURE__ */ e(oe, { icon: l || Ye }),
  /* @__PURE__ */ e(Ot, { titleText: A, headingLevel: "h1" }),
  /* @__PURE__ */ e(kt, { children: t }),
  /* @__PURE__ */ v(Tt, { children: [
    i && /* @__PURE__ */ e(
      X,
      {
        "data-testid": `${A.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: "primary",
        onClick: n,
        isDisabled: d,
        children: i
      }
    ),
    c,
    s && /* @__PURE__ */ e(Yt, { children: s.map((u) => /* @__PURE__ */ e(
      X,
      {
        "data-testid": `${u.text.replace(/\W+/g, "-").toLowerCase()}-empty-action`,
        variant: u.type || fA.secondary,
        onClick: u.onClick,
        isDisabled: d,
        children: u.text
      },
      u.text
    )) })
  ] })
] }), yr = ({
  toolbarItem: A,
  subToolbar: t,
  toolbarItemFooter: n,
  children: r,
  searchTypeComponent: a,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: l
}) => {
  const { t: d } = S(), [c, u] = w(""), o = (I) => {
    u(I.trim()), l?.(I.trim());
  }, h = (I) => {
    I.key === "Enter" && o(c);
  };
  return /* @__PURE__ */ v(z, { children: [
    /* @__PURE__ */ e(yA, { "data-testid": "table-toolbar", children: /* @__PURE__ */ v(XA, { children: [
      i && /* @__PURE__ */ e(F, { children: /* @__PURE__ */ v(DA, { "data-testid": i, children: [
        a,
        s && /* @__PURE__ */ e(
          Jt,
          {
            "data-testid": "table-search-input",
            placeholder: s,
            "aria-label": d("search"),
            value: c,
            onChange: (I, B) => {
              u(B);
            },
            onSearch: () => o(c),
            onKeyDown: h,
            onClear: () => o("")
          }
        )
      ] }) }),
      A
    ] }) }),
    t && /* @__PURE__ */ e(yA, { children: /* @__PURE__ */ e(XA, { children: t }) }),
    /* @__PURE__ */ e(Lt, {}),
    r,
    /* @__PURE__ */ e(yA, { children: n })
  ] });
}, pe = ({
  id: A,
  variant: t = "top",
  count: n,
  first: r,
  max: a,
  onNextClick: i,
  onPreviousClick: s,
  onPerPageSelect: l
}) => {
  const { t: d } = S(), c = Math.round(r / a);
  return /* @__PURE__ */ e(
    jt,
    {
      widgetId: A,
      titles: {
        paginationAriaLabel: `${d("pagination")} ${t} `
      },
      isCompact: !0,
      toggleTemplate: ({
        firstIndex: u,
        lastIndex: o
      }) => /* @__PURE__ */ v("b", { children: [
        u,
        " - ",
        o
      ] }),
      itemCount: n + c * a,
      page: c + 1,
      perPage: a,
      onNextClick: (u, o) => i((o - 1) * a),
      onPreviousClick: (u, o) => s((o - 1) * a),
      onPerPageSelect: (u, o, h) => l(h - 1, o),
      variant: t
    }
  );
}, fr = ({
  count: A,
  searchTypeComponent: t,
  toolbarItem: n,
  subToolbar: r,
  children: a,
  inputGroupName: i,
  inputGroupPlaceholder: s,
  inputGroupOnEnter: l,
  ...d
}) => /* @__PURE__ */ e(
  yr,
  {
    searchTypeComponent: t,
    toolbarItem: /* @__PURE__ */ v(z, { children: [
      n,
      /* @__PURE__ */ e(F, { variant: "pagination", children: /* @__PURE__ */ e(pe, { count: A, ...d }) })
    ] }),
    subToolbar: r,
    toolbarItemFooter: A !== 0 ? /* @__PURE__ */ e(F, { variant: "pagination", children: /* @__PURE__ */ e(pe, { count: A, variant: "bottom", ...d }) }) : null,
    inputGroupName: i,
    inputGroupPlaceholder: s,
    inputGroupOnEnter: l,
    children: a
  }
), Fe = (A) => !!A && A.title !== void 0, ve = ({
  row: A,
  index: t,
  actions: n,
  actionResolver: r
}) => {
  const a = n || r?.(A, {});
  return /* @__PURE__ */ v(z, { children: [
    A.cells.map((i, s) => /* @__PURE__ */ e(rA, { children: Fe(i) ? i.title : i }, `cell-${s}`)),
    a && a.length > 0 && !A.disableActions && /* @__PURE__ */ e(rA, { isActionCell: !0, children: /* @__PURE__ */ e(pn, { items: a, extraData: { rowIndex: t } }) })
  ] });
}, Br = ({ row: A }) => A.cells.map((t, n) => /* @__PURE__ */ e("div", { children: Fe(t) ? t.title : t }, `cell-${n}`));
function Dr({
  columns: A,
  rows: t,
  actions: n,
  actionResolver: r,
  ariaLabelKey: a,
  selected: i,
  onSelect: s,
  onCollapse: l,
  canSelectAll: d,
  canSelect: c,
  isNotCompact: u,
  isRadio: o,
  ...h
}) {
  const { t: I } = S(), [B, k] = w(i || []), [m, g] = w([]), Q = G(
    () => un(
      B,
      t.map((p) => p.data),
      "id"
    ),
    [B, t]
  );
  nA(() => {
    if (d) {
      const p = document.getElementsByName("check-all").item(0);
      if (p) {
        const M = p;
        M.indeterminate = Q.length < t.length && Q.length > 0;
      }
    }
  }, [B, d, t]);
  const E = (p) => {
    k(p), s?.(p);
  }, y = (p, M) => {
    if (o) {
      const T = M ? [t[p].data] : [];
      E(T);
    } else if (p === -1) {
      const T = Q.map(
        (b) => R(b, "id")
      );
      E(
        M ? [...B, ...t.map((b) => b.data)] : B.filter(
          (b) => !T.includes(R(b, "id"))
        )
      );
    } else
      E(M ? [...B, t[p].data] : B.filter(
        (T) => R(T, "id") !== t[p].data.id
      ));
  };
  return /* @__PURE__ */ v(
    mn,
    {
      ...h,
      variant: u ? void 0 : Cn.compact,
      "aria-label": I(a),
      children: [
        /* @__PURE__ */ e(In, { children: /* @__PURE__ */ v(vA, { children: [
          l && /* @__PURE__ */ e(YA, { screenReaderText: I("expandRow") }),
          d && /* @__PURE__ */ e(
            YA,
            {
              screenReaderText: I("selectAll"),
              select: o ? void 0 : {
                onSelect: (p, M) => {
                  y(-1, M);
                },
                isSelected: Q.length === t.length
              }
            }
          ),
          A.map((p) => /* @__PURE__ */ e(
            YA,
            {
              screenReaderText: I("expandRow"),
              className: p.transforms?.[0]().className,
              children: I(p.displayKey || p.name)
            },
            p.displayKey || p.name
          ))
        ] }) }),
        l ? t.map((p, M) => /* @__PURE__ */ e(de, { children: M % 2 === 0 ? /* @__PURE__ */ v(vA, { children: [
          /* @__PURE__ */ e(
            rA,
            {
              expand: t[M + 1].cells.length === 0 ? void 0 : {
                isExpanded: !!m[M],
                rowIndex: M,
                expandId: "expandable-row-",
                onToggle: (T, b, j) => {
                  l(j, b);
                  const V = [...m];
                  V[M] = j, g(V);
                }
              }
            }
          ),
          /* @__PURE__ */ e(
            ve,
            {
              row: p,
              index: M,
              actions: n,
              actionResolver: r
            }
          )
        ] }) : /* @__PURE__ */ v(vA, { isExpanded: !!m[M - 1], children: [
          /* @__PURE__ */ e(rA, {}),
          /* @__PURE__ */ e(rA, { colSpan: A.length, children: /* @__PURE__ */ e(hn, { children: /* @__PURE__ */ e(Br, { row: p }) }) })
        ] }) }, M)) : /* @__PURE__ */ e(de, { children: t.map((p, M) => /* @__PURE__ */ v(vA, { isExpanded: m[M], children: [
          c && /* @__PURE__ */ e(
            rA,
            {
              select: {
                rowIndex: M,
                onSelect: (T, b, j) => {
                  y(j, b);
                },
                isSelected: !!B.find(
                  (T) => R(T, "id") === p.data.id
                ),
                variant: o ? "radio" : "checkbox",
                isDisabled: p.disableSelection
              }
            }
          ),
          /* @__PURE__ */ e(
            ve,
            {
              row: p,
              index: M,
              actions: n,
              actionResolver: r
            }
          )
        ] }, M)) })
      ]
    }
  );
}
function Er({
  ariaLabelKey: A,
  searchPlaceholderKey: t,
  isPaginated: n = !1,
  onSelect: r,
  canSelectAll: a = !1,
  isNotCompact: i,
  isRadio: s,
  detailColumns: l,
  isRowDisabled: d,
  loader: c,
  columns: u,
  actions: o,
  actionResolver: h,
  searchTypeComponent: I,
  toolbarItem: B,
  subToolbar: k,
  emptyState: m,
  icon: g,
  isSearching: Q = !1,
  ...E
}) {
  const { t: y } = S(), [p, M] = w([]), [T, b] = w(), [j, V] = w(), [J, C] = w(!1), [f, x] = je(
    localStorage,
    "pageSize",
    10
  ), [O, lA] = w(f), [H, oA] = w(0), [W, OA] = w(""), ee = U(), [CA, ze] = w(0), te = U(), ne = () => ze(CA + 1), We = be(), re = (D, Y) => D.map((L) => {
    if ("cellFormatters" in L) {
      const $ = R(Y, L.name);
      return L.cellFormatters?.reduce((cA, hA) => hA(cA), $);
    }
    if (L.cellRenderer) {
      const $ = L.cellRenderer;
      return { title: /* @__PURE__ */ e($, { ...Y }) };
    }
    return R(Y, L.name);
  }), ae = (D) => {
    const Y = (L) => l?.[0]?.enabled?.(L);
    return D.map((L, $) => {
      const cA = d ? d(L) : !1, hA = [
        {
          data: L,
          disableSelection: cA,
          disableActions: cA,
          selected: !!p.find((_e) => R(_e, "id") === R(L, "id")),
          isOpen: Y(L) ? !1 : void 0,
          cells: re(u, L)
        }
      ];
      return l && hA.push({
        parent: $ * 2,
        cells: Y(L) ? re(l, L) : []
      }), hA;
    }).flat();
  }, kA = (D) => ["string", "number"].includes(typeof D) ? D.toString() : D instanceof Array ? D.map(kA).join("") : typeof D == "object" ? kA(
    Gt(D.title) ? D.title.props : Object.values(D)
  ) : "", ie = G(
    () => W === "" || n ? void 0 : ae(j || []).filter(
      (D) => D.cells.some(
        (Y) => Y && kA(Y).toLowerCase().includes(W.toLowerCase())
      )
    ).slice(H, H + O + 1),
    [W, H, O]
  );
  hr(
    async () => {
      C(!0);
      const D = ee.current === "" && W !== "";
      return D && oA(0), ee.current = W, typeof c == "function" ? CA === te.current && j ? j : await c(D ? 0 : H, O + 1, W) : c;
    },
    (D) => {
      te.current = CA, n || (V(D), D.length > H ? D = D.slice(H, H + O + 1) : oA(0));
      const Y = ae(D);
      b(Y), C(!1);
    },
    [
      CA,
      H,
      O,
      W,
      typeof c != "function" ? c : void 0
    ]
  );
  const Ke = () => o && dn(o).map((D, Y) => (delete D.onRowClick, D.onClick = async (L, $) => {
    await o[Y].onRowClick(
      (ie || T)[$].data
    ) && (n || OA(""), ne());
  }, D)), Ue = (D, Y) => {
    _[Y].isOpen = D, b([..._]);
  }, _ = ie || T, IA = !_ || _.length === 0, TA = W !== "" || Q, Ze = l ? O * 2 : O, qe = l ? (_?.length || 0) / 2 : _?.length || 0;
  return /* @__PURE__ */ v(z, { children: [
    (!IA || TA) && /* @__PURE__ */ v(
      fr,
      {
        id: We,
        count: qe,
        first: H,
        max: O,
        onNextClick: oA,
        onPreviousClick: oA,
        onPerPageSelect: (D, Y) => {
          oA(D), lA(Y), x(Y);
        },
        inputGroupName: t ? `${A}input` : void 0,
        inputGroupOnEnter: OA,
        inputGroupPlaceholder: y(t || ""),
        searchTypeComponent: I,
        toolbarItem: /* @__PURE__ */ v(z, { children: [
          B,
          " ",
          /* @__PURE__ */ e(F, { variant: "separator" }),
          " ",
          /* @__PURE__ */ e(F, { children: /* @__PURE__ */ v(X, { variant: "link", onClick: ne, "data-testid": "refresh", children: [
            /* @__PURE__ */ e(ln, {}),
            " ",
            y("refresh")
          ] }) })
        ] }),
        subToolbar: k,
        children: [
          !J && !IA && /* @__PURE__ */ e(
            Dr,
            {
              ...E,
              canSelectAll: a,
              canSelect: !!r,
              selected: p,
              onSelect: (D) => {
                M(D), r?.(D);
              },
              onCollapse: l ? Ue : void 0,
              actions: Ke(),
              actionResolver: h,
              rows: _.slice(0, Ze),
              columns: u,
              isNotCompact: i,
              isRadio: s,
              ariaLabelKey: A
            }
          ),
          !J && IA && TA && /* @__PURE__ */ e(
            vr,
            {
              hasIcon: !0,
              icon: g,
              isSearchVariant: !0,
              message: y("noSearchResults"),
              instructions: y("noSearchResultsInstructions"),
              secondaryActions: Q ? [] : [
                {
                  text: y("clearAllFilters"),
                  onClick: () => OA(""),
                  type: fA.link
                }
              ]
            }
          )
        ]
      }
    ),
    J && /* @__PURE__ */ e(pr, {}),
    !J && IA && !TA && m
  ] });
}
const Qr = ({ link: A, organization: t }) => {
  const { t: n } = S();
  return /* @__PURE__ */ e(vn, { wrapModifier: "truncate", children: /* @__PURE__ */ v(A, { organization: t, children: [
    t.name,
    !t.enabled && /* @__PURE__ */ e(
      St,
      {
        isRead: !0,
        className: "pf-v5-u-ml-sm",
        children: n("disabled")
      },
      `${t.id}-disabled`
    )
  ] }) });
}, Mr = (A) => {
  const { t } = S();
  return /* @__PURE__ */ e(
    ZA,
    {
      numChips: 2,
      expandedText: t("hide"),
      collapsedText: t("showRemaining"),
      children: A.domains?.map((n) => {
        const r = typeof n == "string" ? n : n.name;
        return /* @__PURE__ */ e(qA, { isReadOnly: !0, children: r }, r);
      })
    }
  );
}, aa = ({
  loader: A,
  toolbarItem: t,
  isPaginated: n = !1,
  isSearching: r = !1,
  searchPlaceholderKey: a,
  onSelect: i,
  onDelete: s,
  deleteLabel: l = "delete",
  link: d,
  children: c
}) => {
  const { t: u } = S();
  return /* @__PURE__ */ e(
    Er,
    {
      loader: A,
      isPaginated: n,
      isSearching: r,
      ariaLabelKey: "organizationList",
      searchPlaceholderKey: a,
      toolbarItem: t,
      onSelect: i,
      canSelectAll: i !== void 0,
      actions: s ? [
        {
          title: u(l),
          onRowClick: s
        }
      ] : void 0,
      columns: [
        {
          name: "name",
          displayKey: "name",
          cellRenderer: (o) => /* @__PURE__ */ e(Qr, { link: d, organization: o })
        },
        {
          name: "domains",
          displayKey: "domains",
          cellRenderer: Mr
        },
        {
          name: "description",
          displayKey: "description"
        },
        {
          name: "membershipType",
          displayKey: "membershipType"
        }
      ],
      emptyState: c
    }
  );
};
export {
  xn as AlertProvider,
  Nr as ContinueCancelModal,
  ra as ErrorBoundaryFallback,
  na as ErrorBoundaryProvider,
  On as ErrorPage,
  _r as FileUploadControl,
  Re as FormErrorText,
  Un as FormPanel,
  Aa as FormSubmitButton,
  Jn as Help,
  Xe as HelpItem,
  $r as IconMapper,
  Er as KeycloakDataTable,
  ta as KeycloakMasthead,
  Hr as KeycloakProvider,
  lr as KeycloakSelect,
  pr as KeycloakSpinner,
  Fn as KeycloakTextArea,
  vr as ListEmptyState,
  Vr as NumberControl,
  aa as OrganizationTable,
  fr as PaginatingTableToolbar,
  Fr as PasswordControl,
  Ge as PasswordInput,
  Ar as ScrollForm,
  Pn as SelectControl,
  dA as SelectVariant,
  Ur as SwitchControl,
  yr as TableToolbar,
  Zr as TextAreaControl,
  qr as TextControl,
  ea as UserProfileFields,
  zr as beerify,
  _A as createNamedContext,
  Vn as debeerify,
  En as generateId,
  Bn as getErrorDescription,
  fn as getErrorMessage,
  Pr as getInjectedEnvironment,
  Je as getNetworkErrorDescription,
  Dn as getNetworkErrorMessage,
  Qn as isDefined,
  Kr as isUserProfileError,
  tA as label,
  $n as mainPageContentId,
  Wr as setUserProfileServerError,
  Xr as useAlerts,
  Gr as useEnvironment,
  Ve as useErrorBoundary,
  hr as useFetch,
  Yn as useHelp,
  $A as useRequiredContext,
  Mn as useSetTimeout,
  je as useStoredState
};
